import React, { useEffect, useState } from "react";
import { Link, useRouteError, useNavigate } from "react-router-dom";
import Meta from "../components/custom-ui/meta/Meta";
import ScrollToTop from "../providers/router";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { useAuth } from "../providers/auth";
import PageLoader from "../components/custom-ui/pageLoader/PageLoader";

function NotFoundPage() {
  const error = useRouteError();
  const navigate = useNavigate();
  const { user } = useAuth();

  // loader state
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 3000); // 3 seconds
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center w-screen h-screen">
       <PageLoader/>
      </div>
    );
  }

  return (
    <>
      <Meta title="Oops! Page Not Found - 404" />
      <ScrollToTop />
      <Header />
      <div className="flex items-center flex-col justify-center w-screen h-screen">
        <img
          src="/images/InstantTeamsLogo_Main_1.png"
          className="w-[16%] mt-10 mb-32 h-[6%]"
          alt="Instant Teams Logo"
        />

        <div className="w-[30%] flex flex-col justify-center items-center my-10 h-[5%]">
          <img src="/images/404-newui.png" alt="404 Illustration" />
        </div>

        <p className="font-bold text-2xl mt-20 text-gray-600">
          Sorry, the page you're looking for doesn't exist.
        </p>

        <button
          onClick={() => {
            if (user?.claims?.type === "A") {
              navigate("/dashboardinsight/employers&plan");
            } else if (user?.claims?.type === "E") {
              navigate("/home");
            } else if (user?.claims?.type === "S") {
              navigate("/jobs");
            } else {
              navigate("/auth/signin");
            }
          }}
          className="border-instant-teams-blue-D1 mt-8 border-2 px-8 py-2 rounded-full text-instant-teams-blue-D1"
        >
          Return to Homepage
        </button>
      </div>
      <Footer />
    </>
  );
}

export default NotFoundPage;
